import { render, staticRenderFns } from "./Report_teen.vue?vue&type=template&id=73d18c15&scoped=true&"
import script from "./Report_teen.vue?vue&type=script&lang=js&"
export * from "./Report_teen.vue?vue&type=script&lang=js&"
import style0 from "./Report_teen.vue?vue&type=style&index=0&id=73d18c15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d18c15",
  null
  
)

export default component.exports